module.exports = __webpack_public_path__ + "static/img/site_hover_bg.e75aba61.png";